"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DealResponseCodes;
(function (DealResponseCodes) {
    DealResponseCodes[DealResponseCodes["NO_ACTIVE_DEAL"] = 404005] = "NO_ACTIVE_DEAL";
    DealResponseCodes[DealResponseCodes["ACCESS_CODE_DENIED"] = 403201] = "ACCESS_CODE_DENIED";
    DealResponseCodes[DealResponseCodes["EXPIRED_DEAL"] = 400401] = "EXPIRED_DEAL";
    DealResponseCodes[DealResponseCodes["INVALID_DEAL_STATUS"] = 400413] = "INVALID_DEAL_STATUS";
})(DealResponseCodes = exports.DealResponseCodes || (exports.DealResponseCodes = {}));
